<header>
    <nav>
        <div class="toolbar">
            <mat-toolbar color="primary">
                <span class="branding spacer">
                    <img class="logo" [src]="logo" />
                    <img class="business-logo-nav" src={{businessLogo}} alt="Business Logo" *ngIf="checkLogo()" />
                </span>

            

                <!-- CORONA VIRUS EMERGENCY -->
                <!-- <h1 class="corona-emergency">
                    {{'corona.stayHome' | translate}}
                    {{'corona.title' | translate}}
                </h1> -->
                <cloud-lang-switcher></cloud-lang-switcher>

                <small *ngIf="isAuthenticated && !hasBusinessAccount" class="d-none d-md-inline small name">{{'hi' | translate}}, {{
                    userData?.firstName[lang]}}</small>

                    <small class="d-none d-md-inline small name" *ngIf="isAuthenticated && hasBusinessAccount">
                      {{getName()}}
                    </small>

                <button *ngIf="isAuthenticated" class="profile-container" class="profile" mat-icon-button routerLink="profile"
                    matTooltip="{{'profile' | translate}}" (click)="setCurrentView('profile')" [disabled]="isLoggedInOnlyQES">
                    <cqes-icon icon="account_circle"></cqes-icon>
                </button>

                <button *ngIf="isAuthenticated && hasBusinessAccount" class="switcher" mat-icon-button
                    matTooltip="{{'accountChange' | translate}}" (click)="goToChangeAccount()">
                    <cqes-icon icon="account_box"></cqes-icon>
                </button>

                <button *ngIf="isAuthenticated" mat-icon-button matTooltip="{{'auth.logout' | translate}}"
                    (click)="logout()">
                    <cqes-icon icon="exit_to_app"></cqes-icon>
                </button>
            </mat-toolbar>
        </div>
    </nav>
    <section class="progress-bar">
        <mat-progress-bar mode="indeterminate" [color]="'primary'" [mode]="progressBarMode"></mat-progress-bar>
    </section>
</header>